module.exports = __webpack_public_path__ + "img/08_bg.805b550c.png";